export enum TipusTermini {
  DIES = 484,
  MESOS = 485,
  ANYS = 486
}
